import React from "react";

import { graphql } from "gatsby";

import OptimizedImage from "cms/components/OptimizedImage";

import { Container, Content, Illustration } from "./BigImageBlock.styles";

export interface BigImageBlockProps extends Queries.SanityBigImageBlock {}

const BigImageBlock: React.FC<BigImageBlockProps> = ({ image, imageAlt }) => (
  <Container>
    <Content>
      {image && (
        <Illustration>
          <OptimizedImage image={image} alt={imageAlt} />
        </Illustration>
      )}
    </Content>
  </Container>
);

export const query = graphql`
  fragment BigImageBlock on SanityBigImageBlock {
    _key
    _type
    image { ...OptimizedImage }
    imageAlt
  }
`;

export default BigImageBlock;
